export default __webpack_public_path__ + "static/media/dark-mode.fdb51e7c.svg";